var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqIconNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 16.2422C23.9999 13.264 22.2913 10.606 19.7324 9.31311C19.653 15.0234 15.0233 19.6531 9.31299 19.7325C10.6059 22.2914 13.2639 24 16.2421 24C17.6384 24 18.9963 23.6281 20.1895 22.9215L23.966 23.9661L22.9214 20.1896C23.628 18.9965 23.9999 17.6385 23.9999 16.2422V16.2422Z",
    fill: "#8A9099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 9.16406C18.3281 4.1109 14.2172 0 9.16406 0C4.1109 0 0 4.1109 0 9.16406C0 10.8109 0.438354 12.4144 1.27075 13.8221L0.0336914 18.2943L4.50604 17.0574C5.91376 17.8898 7.51721 18.3281 9.16406 18.3281C14.2172 18.3281 18.3281 14.2172 18.3281 9.16406ZM7.75781 7.03125H6.35156C6.35156 5.48035 7.61316 4.21875 9.16406 4.21875C10.715 4.21875 11.9766 5.48035 11.9766 7.03125C11.9766 7.81842 11.6433 8.57501 11.062 9.10675L9.86719 10.2003V11.2969H8.46094V9.58099L10.1125 8.06927C10.4077 7.79919 10.5703 7.4306 10.5703 7.03125C10.5703 6.2558 9.93951 5.625 9.16406 5.625C8.38861 5.625 7.75781 6.2558 7.75781 7.03125ZM8.46094 12.7031H9.86719V14.1094H8.46094V12.7031Z",
    fill: "#8A9099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIconNormal);
export default __webpack_public_path__ + "static/media/faq-icon-normal.628efda1fd8de932f8c03eff39ba20ac.svg";
export { ForwardRef as ReactComponent };